// extracted by mini-css-extract-plugin
export default {"MenuSelect":"SE0N03kr","header":"UVfvaOzt","current":"Lw1WyghT","icon":"z4eVUNJh","body":"RkjH5Pzq","item":"tiNt9dtb","selected":"qGiQM_LH"};
    if(module.hot) {
      // 1738090061129
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  